import React, { Component, useState } from 'react';

class DeviceNurseryInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
          nursery: null,
          name: '-',
          address: '-',
          tel: '-',
        };
    }

    componentWillReceiveProps = (nextProps) => {        
        this.setState({nursery: nextProps.selectedNursery}, () => {
            this.setState({name: this.state.nursery == null ? '-' : this.state.nursery.name, 
                            address: this.state.nursery == null ? '-' : this.state.nursery.address, 
                            tel: this.state.nursery == null ? '-' : (this.state.nursery.tel ? this.state.nursery.tel : '-')
            })
        })
    }

    componentDidMount() {
    }

    render() {
        return ( 
            <div className="card border-top border-3 border-top-warning mb-1">
                <div className="card-body" style={{}}>
                    <div className="row device-info-field" style={{paddingLeft:"15px", paddingRight:"15px"}}>
                        <div className="col-xl-2 col-lg-2 col-md-2 col-sm-3 col-3 bg-warning text-dark text-center" style={{padding:"15px"}}>
                            원
                        </div>
                        <div className="col-xl-10 col-lg-10 col-md-10 col-sm-9 col-9" style={{padding:"0px"}}>
                            <div className="input-group" style={{borderTop:"1px solid #dddddd", borderBottom:"1px solid #dddddd"}}>
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="">이름</span>
                                </div>
                                <input type="text" disabled={true} className="form-control bg-white" value={this.state.name} />
                            </div>
                            <div className="input-group" style={{borderBottom:"1px solid #dddddd"}}>
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="">주소</span>
                                </div>
                                <input type="text" disabled={true} className="form-control bg-white" value={this.state.address} />
                            </div>
                            <div className="input-group" style={{borderBottom:"1px solid #dddddd"}}>
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="">연락처</span>
                                </div>
                                <input type="text" disabled={true} className="form-control bg-white" value={this.state.tel} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


export default DeviceNurseryInfo;